import React from 'react'

import ChangeTextAnimation from './components/ChangeTextAnimation.jsx'

function ThirthSection() {
  return (
    <div className="min-h-screen flex justify-center items-center flex-col capitalize">
      <p className="text-grey-800 text-3xl md:text-3xl font-bold text-center mb-6 text-white">
        Pengen belajar cukur rambut, tapi bingung harus mulai darimana?
      </p>
      <p className="text-grey-800 text-5xl md:text-3xl font-bold text-center capitalize italic text-white mb-10">
        Anda pemula? gak usah khawatir...
      </p>
      <ChangeTextAnimation/>
    </div>
  )
}


// const texts = [
//   "ANDA AKAN MAHIR MENCUKUR RAMBUT HANYA DALAM HITUNGAN HARI MESKIPUN DARI NOL TANPA BASIC APAPUN",
//   "Tenang, Kami Menyediakan Jasa Cukur Rambut Bergaransi Mengulang Seumur Hidup Dan Bisa Disalurkan Kerja"
//  ];

export default ThirthSection